<div class="flex flex-col gap-2 items-start">
  @if (isLogoValid) {
    <img (error)="setFooterLogoInvalid()" [src]="getFooterLogoUrl()" class="h-6" aria-label="Bank Footer Logo." alt="Bank Footer Logo" />
    <div class="dcp-body-small gray-color-variant text-word-wrap-break py-2" i18n="@@footer.legal"
         [innerHTML]="footerCopyrightAndDisclaimerMessage">
    </div>
  }
</div>
